import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { suppressResizeObserverErrors } from "./Utils/resizeObserverErrorSuppression";
import { Provider } from "react-redux";
import { store } from "./redux/store";

// Suppress ResizeObserver errors globally (common with Stripe Elements)
suppressResizeObserverErrors();
console.log("ResizeObserver error suppression activated");

// Additional global error suppression for ResizeObserver and MutationObserver
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args[0];
  if (
    typeof message === "string" &&
    (message.includes("ResizeObserver") ||
      message.includes("MutationObserver") ||
      message.includes("loop completed with undelivered notifications"))
  ) {
    return; // Suppress ResizeObserver and MutationObserver errors
  }
  originalConsoleError.apply(console, args);
};

// Suppress ResizeObserver and MutationObserver errors in React's error handling
const originalOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (
    typeof message === "string" &&
    (message.includes("ResizeObserver") || message.includes("MutationObserver"))
  ) {
    return true; // Prevent default error handling
  }
  if (originalOnError) {
    return originalOnError(message, source, lineno, colno, error);
  }
  return false;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
